/**
 * How a calendar date is written everywhere in the customer application.
 *
 * This file once held the old policy list's columns, filter and sort, which
 * ran in the browser over a list fetched whole. The list is paged by the
 * server now (library/), and what remains here is the one thing a dozen other
 * screens import from it.
 */

/** Shown wherever a value is absent. */
export const ABSENT = '—';

const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

/** "2027-03-14" becomes "Mar 14, 2027", the order US readers expect. An em dash when absent. */
export function formatDate(iso: string | null): string {
  if (!iso) return ABSENT;
  const [y, m, d] = iso.split('-');
  const month = MONTHS[Number(m) - 1];
  if (!y || !d || !month) return iso;
  return `${month} ${Number(d)}, ${y}`;
}
